import { Colors } from '../../themes/colors';

export const GiftIcon = ({ color = Colors.neutral_600 }) => (
  <svg width="29" height="28" viewBox="0 0 29 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14.5 9.33333V24.5M14.5 9.33333C14.5 9.33333 14.5 7.59176 14.5 7C14.5 5.71134 15.5447 4.66667 16.8333 4.66667C18.122 4.66667 19.1667 5.71134 19.1667 7C19.1667 8.28866 18.122 9.33333 16.8333 9.33333C16.1364 9.33333 14.5 9.33333 14.5 9.33333ZM14.5 9.33333C14.5 9.33333 14.5 7.0734 14.5 6.41667C14.5 4.80584 13.1942 3.5 11.5833 3.5C9.9725 3.5 8.66667 4.80584 8.66667 6.41667C8.66667 8.0275 9.9725 9.33333 11.5833 9.33333C12.5374 9.33333 14.5 9.33333 14.5 9.33333ZM6.33333 14H22.6667M6.33333 14C5.04467 14 4 12.9553 4 11.6667C4 10.378 5.04467 9.33333 6.33333 9.33333H22.6667C23.9553 9.33333 25 10.378 25 11.6667C25 12.9553 23.9553 14 22.6667 14M6.33333 14L6.33333 22.1667C6.33333 23.4553 7.378 24.5 8.66667 24.5H20.3333C21.622 24.5 22.6667 23.4553 22.6667 22.1667V14"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
